import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscriber } from "rxjs";

import { ContextResponse, DefaultService } from "../../../../../api/index";

import {
    RECEIVE_LOGOUT,
    RECEIVE_SESSION_REVIVE,
    REQUEST_LOGOUT,
    REQUEST_SESSION_REVIVE,
    SessionCommonActionFactory
} from "./session.common.action.factory";
import { ReduxAction } from "../../../../core/redux/redux.module";

@Injectable()
export class SessionCommonActionFactoryImpl implements SessionCommonActionFactory {

    protected _defaultService: DefaultService;
    protected _ngrxStore: Store<any>;

    constructor(defaultService: DefaultService,
                ngrxStore: Store<any>
    ) {
       this._defaultService = defaultService;
       this._defaultService.defaultHeaders.append("Content-Type", "application/json");
        this._ngrxStore = ngrxStore;
    }

    public reviveSession(): Observable<ContextResponse> {
        const result: Observable<ContextResponse> = new Observable<ContextResponse>((
            subscriber: Subscriber<any>
        ) => {
            // dispatching initial actions to initialize
            this.requestSessionRevive();

            this._defaultService.revive()
                .subscribe((response: ContextResponse) => {
                    this.receiveSessionRevive(response);
                    subscriber.next(response);
                    subscriber.complete();
                },
                error => {
                    subscriber.error(error);
                });


            return function unsubscribe() {

            };
        });

        return result;
    }

    public logout(): Observable<ContextResponse> {
        const result: Observable<ContextResponse> = new Observable<ContextResponse>((
            subscriber: Subscriber<any>
        ) => {
            // dispatching initial actions to initialize
            this.requestLogout();

            this._defaultService.sessionSwap()
                .subscribe((response: ContextResponse) => {
                    this.receiveLogout(response);
                    subscriber.next(response);
                    subscriber.complete();
                },
                error => {
                    subscriber.error(error);
                });


            return function unsubscribe() {

            };
        });

        return result;
    }

    protected requestSessionRevive(): void {
        this._ngrxStore.dispatch(this.getRequestSessionRevive());
    }

    protected receiveSessionRevive(response: ContextResponse): void {
        this._ngrxStore.dispatch(this.getReceiveSessionRevive(response));
    }

    protected requestLogout(): void {
        this._ngrxStore.dispatch(this.getRequestLogout());
    }

    protected receiveLogout(response: ContextResponse): void {
        this._ngrxStore.dispatch(this.getReceiveLogout(response));
    }

    protected getRequestSessionRevive(): ReduxAction<any> {
        return {
            type: REQUEST_SESSION_REVIVE
        };
    }

    protected getReceiveSessionRevive(response: ContextResponse): ReduxAction<ContextResponse> {
        return {
            type: RECEIVE_SESSION_REVIVE,
            payload: response
        };
    }

    protected getRequestLogout(): ReduxAction<any> {
        return {
            type: REQUEST_LOGOUT
        };
    }

    protected getReceiveLogout(response: ContextResponse): ReduxAction<ContextResponse> {
        return {
            type: RECEIVE_LOGOUT,
            payload: response
        };
    }
}
